/**
 * PROJECT ICONS — 30 SVG variants
 * Each icon: { id, label, svg, color, bg }
 */

export const PROJECT_ICONS = [
  // ── AI / Боты ──
  {
    id: 'bot',
    label: 'Бот',
    color: '#7850ff',
    bg: 'rgba(120,80,255,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="8" width="18" height="13" rx="3" stroke="#7850ff" stroke-width="1.5"/><path d="M9 8V6C9 4.3 10.3 3 12 3C13.7 3 15 4.3 15 6V8" stroke="#7850ff" stroke-width="1.5" stroke-linecap="round"/><circle cx="9" cy="14" r="1.5" fill="#7850ff"/><circle cx="15" cy="14" r="1.5" fill="#7850ff"/><path d="M9 17.5H15" stroke="#7850ff" stroke-width="1.3" stroke-linecap="round"/></svg>`,
  },
  {
    id: 'ai',
    label: 'AI',
    color: '#c084fc',
    bg: 'rgba(192,132,252,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="4" stroke="#c084fc" stroke-width="1.5" fill="rgba(192,132,252,0.1)"/><path d="M12 2V5M12 19V22M4.2 4.2L6.3 6.3M17.7 17.7L19.8 19.8M2 12H5M19 12H22M4.2 19.8L6.3 17.7M17.7 6.3L19.8 4.2" stroke="#c084fc" stroke-width="1.5" stroke-linecap="round"/></svg>`,
  },
  {
    id: 'brain',
    label: 'Нейросеть',
    color: '#a855f7',
    bg: 'rgba(168,85,247,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><path d="M9 3C7.3 3 6 4.3 6 6C6 6.7 6.3 7.3 6.7 7.8C5.1 8.4 4 9.9 4 11.7C4 13.1 4.7 14.3 5.8 15.1C5.3 15.7 5 16.5 5 17.4C5 19.4 6.6 21 8.5 21C9.1 21 9.7 20.8 10.2 20.5C10.8 21.4 11.8 22 13 22C15.2 22 17 20.2 17 18C17 17.7 17 17.4 16.9 17.1C18.2 16.4 19 15 19 13.5C19 12.5 18.6 11.6 18 10.9C18.6 10.2 19 9.3 19 8.3C19 6.5 17.7 5 16 4.7C15.7 3.7 14.8 3 13.7 3C13 3 12.4 3.3 12 3.7C11.5 3.3 10.8 3 10 3C9.7 3 9.3 3 9 3Z" stroke="#a855f7" stroke-width="1.3" fill="rgba(168,85,247,0.08)"/><circle cx="12" cy="12" r="2" fill="#a855f7" opacity="0.7"/></svg>`,
  },

  // ── Сайты / Приложения ──
  {
    id: 'globe',
    label: 'Сайт',
    color: '#38bdf8',
    bg: 'rgba(56,189,248,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="#38bdf8" stroke-width="1.5"/><path d="M3 12H21M12 3C12 3 8 7 8 12C8 17 12 21 12 21C12 21 16 17 16 12C16 7 12 3 12 3Z" stroke="#38bdf8" stroke-width="1.3" stroke-linecap="round"/></svg>`,
  },
  {
    id: 'app',
    label: 'Приложение',
    color: '#38bdf8',
    bg: 'rgba(56,189,248,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><rect x="5" y="2" width="14" height="20" rx="3" stroke="#38bdf8" stroke-width="1.5"/><path d="M10 18H14" stroke="#38bdf8" stroke-width="1.5" stroke-linecap="round"/><path d="M9 6H15M9 9H13" stroke="#38bdf8" stroke-width="1.2" stroke-linecap="round"/></svg>`,
  },
  {
    id: 'miniapp',
    label: 'Мини-приложение',
    color: '#7850ff',
    bg: 'rgba(120,80,255,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><rect x="2" y="5" width="20" height="16" rx="2.5" stroke="#7850ff" stroke-width="1.5"/><path d="M8 2L8 6M16 2L16 6" stroke="#7850ff" stroke-width="1.5" stroke-linecap="round"/><rect x="6" y="10" width="5" height="5" rx="1.5" fill="rgba(120,80,255,0.3)" stroke="#7850ff" stroke-width="1"/><path d="M14 12H18M14 15H16" stroke="#7850ff" stroke-width="1.2" stroke-linecap="round"/></svg>`,
  },

  // ── E-commerce ──
  {
    id: 'shop',
    label: 'Магазин',
    color: '#34d399',
    bg: 'rgba(52,211,153,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><path d="M2 3H4.5L7 16H18L20 7H7" stroke="#34d399" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9" cy="19.5" r="1.5" fill="#34d399"/><circle cx="17" cy="19.5" r="1.5" fill="#34d399"/></svg>`,
  },
  {
    id: 'marketplace',
    label: 'Маркетплейс',
    color: '#34d399',
    bg: 'rgba(52,211,153,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><path d="M3 6H21L19 14H5L3 6Z" stroke="#34d399" stroke-width="1.5" stroke-linejoin="round" fill="rgba(52,211,153,0.08)"/><path d="M8 6V4C8 3.4 8.4 3 9 3H15C15.6 3 16 3.4 16 4V6" stroke="#34d399" stroke-width="1.3" stroke-linecap="round"/><path d="M5 20H19M8 17H16" stroke="#34d399" stroke-width="1.3" stroke-linecap="round"/></svg>`,
  },

  // ── Аналитика / Данные ──
  {
    id: 'chart',
    label: 'Аналитика',
    color: '#7850ff',
    bg: 'rgba(120,80,255,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><rect x="3" y="14" width="4" height="7" rx="1.5" fill="#7850ff" opacity="0.7"/><rect x="10" y="9" width="4" height="12" rx="1.5" fill="#7850ff"/><rect x="17" y="4" width="4" height="17" rx="1.5" fill="#c084fc"/><path d="M4 11L10 7L16 9.5L21 5" stroke="rgba(192,132,252,0.6)" stroke-width="1.2" stroke-linecap="round" stroke-dasharray="2 2"/></svg>`,
  },
  {
    id: 'dashboard',
    label: 'Дашборд',
    color: '#c084fc',
    bg: 'rgba(192,132,252,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><rect x="2" y="2" width="9" height="9" rx="2" stroke="#c084fc" stroke-width="1.4" fill="rgba(192,132,252,0.08)"/><rect x="13" y="2" width="9" height="9" rx="2" stroke="#c084fc" stroke-width="1.4" fill="rgba(192,132,252,0.05)"/><rect x="2" y="13" width="9" height="9" rx="2" stroke="#c084fc" stroke-width="1.4" fill="rgba(192,132,252,0.05)"/><rect x="13" y="13" width="9" height="9" rx="2" stroke="#c084fc" stroke-width="1.4" fill="rgba(192,132,252,0.08)"/></svg>`,
  },

  // ── Финансы ──
  {
    id: 'fintech',
    label: 'Финтех',
    color: '#fbbf24',
    bg: 'rgba(251,191,36,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><rect x="2" y="6" width="20" height="13" rx="2.5" stroke="#fbbf24" stroke-width="1.5" fill="rgba(251,191,36,0.06)"/><circle cx="12" cy="12.5" r="3" stroke="#fbbf24" stroke-width="1.3"/><path d="M12 10.5V10M12 15V14.5" stroke="#fbbf24" stroke-width="1" stroke-linecap="round"/><path d="M10.5 11.5H12.5C12.8 11.5 13 11.7 13 12C13 12.3 12.8 12.5 12.5 12.5H11.5C11.2 12.5 11 12.7 11 13C11 13.3 11.2 13.5 11.5 13.5H13.5" stroke="#fbbf24" stroke-width="0.9" stroke-linecap="round"/><circle cx="5" cy="12.5" r="1.2" fill="#fbbf24" opacity="0.5"/><circle cx="19" cy="12.5" r="1.2" fill="#fbbf24" opacity="0.5"/></svg>`,
  },
  {
    id: 'crypto',
    label: 'Крипто',
    color: '#fb923c',
    bg: 'rgba(251,146,60,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="#fb923c" stroke-width="1.5" fill="rgba(251,146,60,0.06)"/><path d="M9 8H14C15.1 8 16 8.9 16 10C16 11.1 15.1 12 14 12H9V8Z" stroke="#fb923c" stroke-width="1.3" fill="rgba(251,146,60,0.1)"/><path d="M9 12H14.5C15.9 12 17 13.1 17 14.5C17 15.9 15.9 17 14.5 17H9V12Z" stroke="#fb923c" stroke-width="1.3" fill="rgba(251,146,60,0.1)"/><path d="M9 8V17M11 7V8M11 17V18" stroke="#fb923c" stroke-width="1.2" stroke-linecap="round"/></svg>`,
  },

  // ── Коммуникация ──
  {
    id: 'chat',
    label: 'Чат / CRM',
    color: '#38bdf8',
    bg: 'rgba(56,189,248,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><path d="M4 8C4 6.3 5.3 5 7 5H17C18.7 5 20 6.3 20 8V14C20 15.7 18.7 17 17 17H13L10 21V17H7C5.3 17 4 15.7 4 14V8Z" stroke="#38bdf8" stroke-width="1.5" fill="rgba(56,189,248,0.07)"/><path d="M8 10H16M8 13H13" stroke="#38bdf8" stroke-width="1.3" stroke-linecap="round"/></svg>`,
  },
  {
    id: 'mail',
    label: 'Email / Рассылки',
    color: '#38bdf8',
    bg: 'rgba(56,189,248,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><rect x="3" y="5" width="18" height="14" rx="2" stroke="#38bdf8" stroke-width="1.5" fill="rgba(56,189,248,0.07)"/><path d="M3 9L12 14L21 9" stroke="#38bdf8" stroke-width="1.3" stroke-linecap="round"/></svg>`,
  },

  // ── HR / Рекрутинг ──
  {
    id: 'people',
    label: 'HR / Команда',
    color: '#f472b6',
    bg: 'rgba(244,114,182,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><circle cx="9" cy="7" r="3.5" stroke="#f472b6" stroke-width="1.4" fill="rgba(244,114,182,0.08)"/><circle cx="17" cy="8" r="2.5" stroke="#f472b6" stroke-width="1.2" fill="rgba(244,114,182,0.06)"/><path d="M2 19C2 15.7 5.1 13 9 13C12.9 13 16 15.7 16 19" stroke="#f472b6" stroke-width="1.4" stroke-linecap="round"/><path d="M16 14C18.5 14 21 15.7 21 18" stroke="#f472b6" stroke-width="1.2" stroke-linecap="round" opacity="0.7"/></svg>`,
  },

  // ── Образование ──
  {
    id: 'edu',
    label: 'Образование',
    color: '#fbbf24',
    bg: 'rgba(251,191,36,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><path d="M12 4L2 9L12 14L22 9L12 4Z" fill="rgba(251,191,36,0.12)" stroke="#fbbf24" stroke-width="1.5" stroke-linejoin="round"/><path d="M7 11.5V16.5C7 16.5 9 18.5 12 18.5C15 18.5 17 16.5 17 16.5V11.5" stroke="#fbbf24" stroke-width="1.4" stroke-linecap="round"/><path d="M22 9V14" stroke="#fbbf24" stroke-width="1.4" stroke-linecap="round"/></svg>`,
  },

  // ── Сервисы / Инфраструктура ──
  {
    id: 'server',
    label: 'Сервис / API',
    color: '#a855f7',
    bg: 'rgba(168,85,247,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><rect x="2" y="3" width="20" height="5" rx="2" stroke="#a855f7" stroke-width="1.4" fill="rgba(168,85,247,0.08)"/><rect x="2" y="10" width="20" height="5" rx="2" stroke="#a855f7" stroke-width="1.4" fill="rgba(168,85,247,0.08)"/><rect x="2" y="17" width="20" height="5" rx="2" stroke="#a855f7" stroke-width="1.4" fill="rgba(168,85,247,0.06)"/><circle cx="18" cy="5.5" r="1" fill="#a855f7"/><circle cx="18" cy="12.5" r="1" fill="#a855f7"/><circle cx="18" cy="19.5" r="1" fill="#34d399"/></svg>`,
  },
  {
    id: 'database',
    label: 'База данных',
    color: '#7850ff',
    bg: 'rgba(120,80,255,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><ellipse cx="12" cy="6" rx="8" ry="3" stroke="#7850ff" stroke-width="1.4" fill="rgba(120,80,255,0.1)"/><path d="M4 6V12C4 13.7 7.6 15 12 15C16.4 15 20 13.7 20 12V6" stroke="#7850ff" stroke-width="1.4"/><path d="M4 12V18C4 19.7 7.6 21 12 21C16.4 21 20 19.7 20 18V12" stroke="#7850ff" stroke-width="1.4"/></svg>`,
  },
  {
    id: 'api',
    label: 'Интеграция',
    color: '#c084fc',
    bg: 'rgba(192,132,252,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><path d="M10 13C10.4 13.6 10.9 14.1 11.5 14.5C12.1 14.9 12.8 15.1 13.6 15.1C14.4 15.1 15.1 14.8 15.7 14.4L18.7 11.4C19.8 10.3 19.8 8.5 18.7 7.4C17.6 6.3 15.8 6.3 14.7 7.4L13.1 9" stroke="#c084fc" stroke-width="1.5" stroke-linecap="round"/><path d="M14 11C13.6 10.4 13.1 9.9 12.5 9.5C11.9 9.1 11.2 8.9 10.4 8.9C9.6 8.9 8.9 9.2 8.3 9.6L5.3 12.6C4.2 13.7 4.2 15.5 5.3 16.6C6.4 17.7 8.2 17.7 9.3 16.6L10.9 15" stroke="#c084fc" stroke-width="1.5" stroke-linecap="round"/></svg>`,
  },

  // ── Автоматизация ──
  {
    id: 'automation',
    label: 'Автоматизация',
    color: '#fb923c',
    bg: 'rgba(251,146,60,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><path d="M12 2V6M12 18V22M4.9 4.9L7.8 7.8M16.2 16.2L19.1 19.1M2 12H6M18 12H22M4.9 19.1L7.8 16.2M16.2 7.8L19.1 4.9" stroke="#fb923c" stroke-width="1.5" stroke-linecap="round"/><circle cx="12" cy="12" r="4" stroke="#fb923c" stroke-width="1.5" fill="rgba(251,146,60,0.1)"/></svg>`,
  },
  {
    id: 'n8n',
    label: 'Воркфлоу',
    color: '#fb923c',
    bg: 'rgba(251,146,60,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><circle cx="4" cy="12" r="2.5" stroke="#fb923c" stroke-width="1.4" fill="rgba(251,146,60,0.1)"/><circle cx="12" cy="5" r="2.5" stroke="#fb923c" stroke-width="1.4" fill="rgba(251,146,60,0.1)"/><circle cx="12" cy="19" r="2.5" stroke="#fb923c" stroke-width="1.4" fill="rgba(251,146,60,0.1)"/><circle cx="20" cy="12" r="2.5" stroke="#fb923c" stroke-width="1.4" fill="rgba(251,146,60,0.1)"/><path d="M6.5 12H9.5M14.5 5L17.5 10M14.5 19L17.5 14" stroke="#fb923c" stroke-width="1.3" stroke-linecap="round"/></svg>`,
  },

  // ── Медицина / Здоровье ──
  {
    id: 'health',
    label: 'Здоровье',
    color: '#34d399',
    bg: 'rgba(52,211,153,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><path d="M12 21C12 21 3 15 3 9C3 6.2 5.2 4 8 4C9.7 4 11.2 4.8 12 6.1C12.8 4.8 14.3 4 16 4C18.8 4 21 6.2 21 9C21 15 12 21 12 21Z" stroke="#34d399" stroke-width="1.5" fill="rgba(52,211,153,0.08)"/><path d="M9 10H15M12 7V13" stroke="#34d399" stroke-width="1.5" stroke-linecap="round"/></svg>`,
  },

  // ── Недвижимость ──
  {
    id: 'realty',
    label: 'Недвижимость',
    color: '#fbbf24',
    bg: 'rgba(251,191,36,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><path d="M3 21V10L12 3L21 10V21H15V16H9V21H3Z" stroke="#fbbf24" stroke-width="1.5" stroke-linejoin="round" fill="rgba(251,191,36,0.07)"/></svg>`,
  },

  // ── Логистика ──
  {
    id: 'delivery',
    label: 'Логистика',
    color: '#38bdf8',
    bg: 'rgba(56,189,248,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><path d="M1 9H15V19H1V9Z" stroke="#38bdf8" stroke-width="1.4" fill="rgba(56,189,248,0.07)"/><path d="M15 13H19L22 17V19H15V13Z" stroke="#38bdf8" stroke-width="1.4" stroke-linejoin="round" fill="rgba(56,189,248,0.1)"/><circle cx="5.5" cy="21" r="2" fill="#38bdf8"/><circle cx="18.5" cy="21" r="2" fill="#38bdf8"/></svg>`,
  },

  // ── Контент / Медиа ──
  {
    id: 'media',
    label: 'Контент / Медиа',
    color: '#f472b6',
    bg: 'rgba(244,114,182,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><rect x="2" y="4" width="20" height="14" rx="2.5" stroke="#f472b6" stroke-width="1.5" fill="rgba(244,114,182,0.07)"/><path d="M10 9L16 12L10 15V9Z" fill="#f472b6" opacity="0.8"/><path d="M6 20H18" stroke="#f472b6" stroke-width="1.4" stroke-linecap="round"/></svg>`,
  },

  // ── Безопасность ──
  {
    id: 'security',
    label: 'Безопасность',
    color: '#7850ff',
    bg: 'rgba(120,80,255,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><path d="M12 2L4 6V12C4 16.4 7.5 20.5 12 22C16.5 20.5 20 16.4 20 12V6L12 2Z" stroke="#7850ff" stroke-width="1.5" fill="rgba(120,80,255,0.08)"/><path d="M9 12.5L11.5 15L15.5 10" stroke="#7850ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  },

  // ── Общее ──
  {
    id: 'tool',
    label: 'Инструмент',
    color: '#a855f7',
    bg: 'rgba(168,85,247,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><path d="M14.7 6.3C14.1 5.7 13.3 5.3 12.4 5.3C10.5 5.3 9 6.8 9 8.7C9 9.3 9.2 9.8 9.4 10.2L4.6 15C4.2 15.4 4 16 4 16.5C4 17.6 4.9 18.5 6 18.5C6.5 18.5 7 18.3 7.4 17.9L12.2 13.1C12.6 13.3 13.1 13.4 13.6 13.4C15.5 13.4 17 11.9 17 10C17 9.2 16.7 8.5 16.2 7.9L14 10.1L12.8 8.9L14.7 6.3Z" stroke="#a855f7" stroke-width="1.4" fill="rgba(168,85,247,0.08)" stroke-linejoin="round"/></svg>`,
  },
  {
    id: 'rocket',
    label: 'Стартап',
    color: '#f472b6',
    bg: 'rgba(244,114,182,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><path d="M12 2C12 2 20 4 20 12C20 16 17 19 14 20L10 16C8 13 8 9 12 2Z" stroke="#f472b6" stroke-width="1.5" fill="rgba(244,114,182,0.08)"/><circle cx="13" cy="10" r="1.5" fill="#f472b6" opacity="0.7"/><path d="M6 14C6 14 4 16 4 18L6 20L8 18" stroke="#f472b6" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  },
  {
    id: 'game',
    label: 'Игры',
    color: '#c084fc',
    bg: 'rgba(192,132,252,0.12)',
    svg: `<svg viewBox="0 0 24 24" fill="none"><rect x="2" y="7" width="20" height="12" rx="4" stroke="#c084fc" stroke-width="1.5" fill="rgba(192,132,252,0.08)"/><path d="M7 13H11M9 11V15" stroke="#c084fc" stroke-width="1.5" stroke-linecap="round"/><circle cx="15" cy="12" r="1" fill="#c084fc"/><circle cx="17" cy="14" r="1" fill="#c084fc"/></svg>`,
  },
] as const;

export type ProjectIconId = (typeof PROJECT_ICONS)[number]['id'];

const PROJECT_ICON_SRC_CACHE = new Map<string, string>();

function normalizeSvgForImage(svg: string): string {
  if (svg.includes('xmlns=')) return svg;
  return svg.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" ');
}

function svgToDataUri(svg: string): string {
  const normalizedSvg = normalizeSvgForImage(svg);
  const cached = PROJECT_ICON_SRC_CACHE.get(normalizedSvg);
  if (cached) return cached;

  const encoded = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(normalizedSvg)}`;
  PROJECT_ICON_SRC_CACHE.set(normalizedSvg, encoded);
  return encoded;
}

/** Look up an icon by ID, falls back to first icon */
export function getProjectIcon(id: string | null | undefined) {
  if (!id) return PROJECT_ICONS[0];
  return PROJECT_ICONS.find((i) => i.id === id) ?? PROJECT_ICONS[0];
}

export function getProjectIconAsset(id: string | null | undefined) {
  const icon = getProjectIcon(id);
  return {
    ...icon,
    src: svgToDataUri(icon.svg),
  };
}
